import theme from '../../theme';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';


export const TabStack = styled(Stack)(({ theme }) => ({
  margin: '32px 0 16px 0',
  padding: '8px 0 8px 0',
  borderBottom: `1px solid ${theme.palette.grey.w300}`,
  color: theme.palette.grey.w600
}));

export const TabTitle = styled(Typography)(({ tab, color, type }) => {
  if (type === 'reportData') {
    return {
      color: !tab ? color : theme.palette.grey.w600,
      fontWeight: !tab ? 600 : 300,
      cursor: 'pointer'
    }
  }
  return {
    color: tab ? color : theme.palette.grey.w600,
    fontWeight: tab ? 600 : 300,
    cursor: 'pointer'
  }
});

